module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/snow-8ba78cd020e1489b9790c161fbfc9977.svg";